<template>
  <vue-scroll :ops="ops" ref="vs">
    <slot></slot>
  </vue-scroll>
</template>

<script>
import vueScroll from './vue-scroll.js'
export default {
  name: 'VScroll',
  provide() {
    return {
      getPosition: this.getPosition,
      scrollTo: this.scrollTo
    }
  },
  components: {
    vueScroll
  },
  props: {
    scrollingX: {
      type: Boolean,
      default: true
    },
    scrollingY: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  watch: {},
  data() {
    return {
      ops: {
        vuescroll: {
          wheelScrollDuration: 300,
          detectResize: false
        },
        scrollPanel: {
          easing: 'easeOutQuad',
          scrollingX: this.scrollingX,
          scrollingY: this.scrollingY
        },
        rail: {},
        bar: {
          background: 'rgba(120, 120, 120, 0.4)'
        }
      }
    }
  },
  methods: {
    getPosition() {
      const { scrollTop, scrollLeft } = this.$refs['vs'].getPosition()
      return { scrollTop, scrollLeft }
    },
    scrollBy(params = {}, speed = 500, type = undefined) {
      this.$refs.vs.scrollBy(params, speed, type)
    },
    scrollTo(params = {}, speed = 500, type = undefined) {
      this.$refs.vs.scrollTo(params, speed, type)
    }
  }
}
</script>

<style scoped lang="less"></style>
